import { appTranslate } from '../../../../../i18n';
import { MAX_RATINGS_COUNT } from '../GigRating.constants';

interface GetCountProps {
    count: number;
}

export const getCount = ({ count }: GetCountProps) => {
    if (!count) {
        return null;
    }

    if (count > MAX_RATINGS_COUNT) {
        const formattedCount = Math.floor(count / 1000);

        return appTranslate('gig_cards.count_format', { params: { count: formattedCount } });
    }

    return count;
};
